import React from "react";

const SearchSuggestion = ({ content, type, onClick, id=null, hover_color="#e1e1e1" }) => {

    if (id) {
        var type_key = "Instance"
    } else {
        var type_key = "Group"
    }

    let style_str = `.search-suggestion {
        padding: 10px;
        border-radius: 10px;
      }

      .search-suggestion:hover {
        background: ` + hover_color + `
      }

      .search-suggestion.highlighted {
        background: ` + hover_color + `
      }
`
  

    return (
      <>
        <style>{style_str}</style>
        <div role="button" className="search-suggestion flex-column" style={{gap: "2px"}} onClick={onClick}> 
            <div className="flex-row space-between">
              <span className="font-xs">{type_key}: {type}</span>
              {id && <span className="font-xs">ID: #{id}</span>}
            </div>
            <span className="font-medium" style={{wordBreak: "break-word"}}>{content}</span>
        </div>
      </>
    );
  };
  
export default SearchSuggestion;